import Vue from 'vue'
import VueEvents from 'vue-events'
import VueNotification from '@kugatsu/vuenotification'
import money from 'v-money'
import excel from 'vue-excel-export'
import VModal from 'vue-js-modal'
import VueResource from 'vue-resource'
import VuePikaday from '@enrian/vue-pikaday'
import '@enrian/vue-pikaday/dist/vue-pikaday.min.css'
import VueTimepicker from 'vue2-timepicker'
import 'vue2-timepicker/dist/VueTimepicker.css'
import BootstrapVue from 'bootstrap-vue'
import { VueMaskDirective } from 'v-mask'

import App from './App'
import router from './routes'
import store from './store'

window.jQuery = require('jquery')

Vue.config.productionTip = false

Vue.use(money, { precision: 4 })
Vue.directive('mask', VueMaskDirective)
Vue.use(excel)
Vue.use(VueEvents)
Vue.use(VueResource)
Vue.use(BootstrapVue)
Vue.use(VModal, { dialog: true })
Vue.use(VuePikaday)
Vue.component('vue-timepicker', VueTimepicker)
Vue.use(VueNotification, {
  position: 'bottomCenter',
  timer: 20,
  success: {
    background: '#38A169',
    color: 'white'
  },
  error: {
    background: '#F56565',
    color: 'white'
  }
})

// eslint-disable-next-line no-new
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App },
  VueResource: VueResource
})



// WEBPACK FOOTER //
// ./src/main.js